import { useEffect } from 'react';
import { useSnackbar } from 'notistack';

type HandledError = {
  message?: string;
  response?: {
    status?: number;
    data?: { message?: string };
    errors?: { message?: string }[];
  };
};

export default function useHandleError(error?: Error | null) {
  const snackbar = useSnackbar();

  const handleError = (error: unknown) => {
    console.error('error', error);
    if (!window.Cypress) {
      const handledError = (error ?? {}) as HandledError;
      let message: string | undefined = 'Sorry, something went wrong';
      if (handledError.response?.status === 401) {
        message = 'You do not have permission to perform this action';
      }
      const status = handledError.response?.status;
      if (status !== undefined && status < 500) {
        const railsError = handledError.response?.data?.message;
        const gqlError = handledError.response?.errors?.map(({ message }) => message)?.join(', ');
        const jsError = handledError.message;
        message = railsError || gqlError || jsError;
      }
      snackbar.enqueueSnackbar(message, { variant: 'error' });
    }
    return error;
  };

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error]);

  return handleError;
}
